import { planTypes } from '@/common/constants';
import { mapGetters, mapState, mapMutations } from "vuex";
import { utils, DESK_PHONES_DIALOG } from '@zoom/billing-shared';
import { hideModalDialogCloseButton, showModalDialogCloseButton } from '@/utils/modal-utils';

export default {
  data() {
    return {
      logo: require('@/assets/plans/hardware_desk_phones.svg'),
      title: this.$t('billing.hw.desk_phones.addon.title'),
      planType: planTypes.DESK_PHONES,
      configDescription: 'configDescription',
      description: this.$t('billing.hw.desk_phones.addon.desc'),
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
      allPlanMap: state => state.ShoppingCart.allPlanMap
    }),
    ...mapGetters(['getSelectedPlans']),
    mx_planList() {
      return this.planMapFlat.filter((p) => p.type === planTypes.DESK_PHONES);
    },
    mx_currentSellerId() {
      return this.mx_planList[0]?.__originData?.sellerId
    },
    mx_currentVendorData() {
      return this.allPlanMap.__vendorsData?.vendors?.find(item => item.id === this.mx_currentSellerId)
    },
    mx_returnPolicy() {
      return this.mx_currentVendorData?.returnUrl
    },
    mx_privacyPolicy() {
      return this.mx_currentVendorData?.privacyUrl
    },
    mx_rmaUrl() {
      return this.mx_currentVendorData?.rmaUrl
    },
    mx_helpUrl() {
      return this.mx_currentVendorData?.helpUrl
    },
    mx_deskPhoneDialogProducts() {
      return this.mx_planList.map(item => ({
        ...item.__originData,
        _disabled: !!item.cartInfo.selected_number
      }))
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    async mx_openDeskPhoneDialog() {
      const planName = this.mx_deskPhoneDialogProducts.find(item => item._disabled)?.name;
      if (planName) {
        this.$tracking.buyInteraction('add another phone model', `desk phones - ${planName} - add another phone model`);
      } else {
        this.$tracking.buyInteraction('add another phone model', `desk phones - view phones`);
      }
      hideModalDialogCloseButton()
      return new Promise((resolve) => {
        const loading = this.$loading()
        utils?.showDialog(DESK_PHONES_DIALOG, {
          visible: true,
          loading: false,
          returnPolicy: this.mx_returnPolicy,
          privacyPolicy: this.mx_privacyPolicy,
          products: this.mx_deskPhoneDialogProducts
        }, {
          addToCart: (data) => {
            this.handleAddNewOne(data)
            resolve(data)
          },
          close: () => {
            showModalDialogCloseButton()
          }
        }).then(() => {
          loading.close()
        })
      })
    },
    handleAddNewOne(data) {
      const { items } = data

      this.updateSelectPlan({
        plan_code: `${items[0].itemMarketId}`,
        cartInfo: { selected_number: 1 },
      });
    }
  }
};
